import React, { useEffect, useState } from 'react';
import { Menu, X } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 10);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    name: 'About',
    href: '#hero'
  }, {
    name: 'Expertise',
    href: '#pillars'
  }, {
    name: 'Experience',
    href: '#experience'
  }, {
    name: 'Contact',
    href: '#footer'
  }];
  return <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-[#FDFBF7]/95 backdrop-blur-sm shadow-sm py-4' : 'bg-[#FDFBF7] py-6'}`} data-id="element-197">
      <div className="max-w-7xl mx-auto px-6 md:px-12 flex items-center justify-between" data-id="element-198">
        <a href="#" className="text-2xl font-bold text-corporate-blue tracking-tight" data-id="element-199">
          PETER SHELDON
        </a>

        {/* Desktop Nav */}
        <nav className="hidden md:flex items-center space-x-8" data-id="element-200">
          {navLinks.map(link => <a key={link.name} href={link.href} className="text-sm font-medium text-[#7A7062] hover:text-corporate-blue transition-colors" data-id="element-201">
              {link.name}
            </a>)}
          <a href="#footer" className="px-5 py-2 bg-corporate-blue text-white text-sm font-medium rounded hover:bg-opacity-90 transition-all" data-id="element-202">
            Get in Touch
          </a>
        </nav>

        {/* Mobile Menu Button */}
        <button className="md:hidden text-corporate-blue" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} data-id="element-203">
          {isMobileMenuOpen ? <X size={24} data-id="element-204" /> : <Menu size={24} data-id="element-205" />}
        </button>
      </div>

      {/* Mobile Nav */}
      <AnimatePresence data-id="element-206">
        {isMobileMenuOpen && <motion.div initial={{
        opacity: 0,
        height: 0
      }} animate={{
        opacity: 1,
        height: 'auto'
      }} exit={{
        opacity: 0,
        height: 0
      }} className="md:hidden bg-[#FDFBF7] border-t border-[#E8E0D0] overflow-hidden" data-id="element-207">
            <nav className="flex flex-col p-6 space-y-4" data-id="element-208">
              {navLinks.map(link => <a key={link.name} href={link.href} className="text-base font-medium text-[#6B6356] hover:text-corporate-blue" onClick={() => setIsMobileMenuOpen(false)} data-id="element-209">
                  {link.name}
                </a>)}
            </nav>
          </motion.div>}
      </AnimatePresence>
    </header>;
}